<template>
  <div class="serach-box-head">
    <div class="searchbutton">
      <button type="search"><img src="/static/front/images/menu-images/search-button.svg" alt="srach"></button>
        <input type="text" v-model="input" @click="onChange($event)" @keyup="result()" placeholder="Type to search for a feature or a project..." />
      </div>
      <div class="search-result" v-show='flagForm && input' ref="popup">
        <h6>SEARCH OPTIONS</h6>
        <ul>
          <li>
            <a :href="'/view-all-projects?keyword=' + input" class="" target="_blank">
              <div class="search-icon"><img src="/static/front/images/menu-images/search-button.svg" alt="search"></div>
              <h5>Project search term: <span class="searchKey">{{input}}</span></h5>
              <span class="redirect-link"><img src="/static/front/images/menu-images/redirect-icon.svg" alt="search"></span>
            </a>
          </li>
          <li v-if="searchResult" v-for="result in searchResult" :key="result.id">
            <a :href="result.page_url" class="" :target="result.external_link === 'yes' ? '_blank' : ''">
              <div class="search-icon"><img src="/static/front/images/menu-images/search-button.svg" alt="search"></div>
              <h5>Page search: <span class="searchKey">{{result.page_name}}</span></h5>
              <span class="redirect-link"><img src="/static/front/images/menu-images/redirect-icon.svg" alt="search"></span>
            </a>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import searchAPI from '../../api/search'

export default {
  props: ['user'],
  methods: {
    onChange (event) {
      this.flagForm = !this.flagForm
    },
    result () {
      console.log(this.user)
      let data = {
        keyword: this.input,
        user_account: this.user ? this.user.account : 'company'
      }
      searchAPI.get(data).then((response) => {
        this.searchResult = response
        console.log(this.searchResult)
      })
    }
  },
  data () {
    return {
      input: '',
      flagForm: false,
      searchResult: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business/SearchKeyword.vue